export default "__VITE_ASSET__d588336d__"